// const baseUrl = "http://localhost:8000/api/v1";
const baseUrl = "https://bluediamondvoyage.com/api/v1";
// const baseUrl = "https://nexcorp.in/api/v1";


const homePageData = `${baseUrl}/pages/details/home`;
const aboutPageData = `${baseUrl}/pages/details/about`;
const destinationsPageData = `${baseUrl}/pages/details/destinations`;
const experiencesPageData = `${baseUrl}/pages/details/experiences`;
const servicesPageData = `${baseUrl}/pages/details/service`;
const quizPageData = `${baseUrl}/pages/details/quiz`;
const submitQuizData = `${baseUrl}/quiz/create`;
const getTimeSlotsData = `${baseUrl}/google-calendar/free-slots`;
const createMeeting = `${baseUrl}/google-calendar/create`;
const createInquiry = `${baseUrl}/quick-inquiry/create-quick-inquiry`;
const getFaqList = `${baseUrl}/faq/list-faqs`;
const getPricingList = `${baseUrl}/quiz-pricing/list`;
const getFooterData = `${baseUrl}/footer/list`;

export default {
  homePageData,
  aboutPageData,
  destinationsPageData,
  experiencesPageData,
  servicesPageData,
  quizPageData,
  submitQuizData,
  getTimeSlotsData,
  createMeeting,
  createInquiry,
  getFaqList,
  getPricingList,
  getFooterData
};
